import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { ChevronRight, Left } from '../../../components/Icon';

import { PageHeader } from '../../../components/PageHeader';
import { selectWorks } from '../../Api/selectors';
import { fetchTransportOrder } from '../actions';
import { REQUEST_TRANSPORT_ORDER } from '../constants';
import { selectTransportOrder } from '../selectors';

import { TransportOrderDetailsColumns } from './detailsColumns';
import LoadingDetailsPage from '../../../containers/App/Components/LoadingDetailsPage/LoadingDetailsPage';

/* eslint-disable react/prefer-stateless-function */
class TransportOrderDetailsComp extends BaseComponent {
  constructor(props) {
    super(props, {});
    this.goBack = this.goBack.bind(this);
  }

  componentDidMount() {
    this.props.fetch();

    console.log('\n\n\n=== window.history.location: ', window.history.location);
  }

  goBack(event) {
    window.history.go(-1);
  }

  get transportOrder() {
    return this.props.transportOrder;
  }

  render() {
    if (!this.transportOrder)
      return (
        <>
          <PageHeader
            title={
              <div
                className="pointer"
                onClick={() => {
                  this.props.history.push(back_url, { state: { fromVehicleDetails: true } });
                }}
              >
                <Left />
                {this.lbl('vehicle.overview.title')}
              </div>
            }
            breadCrumbs={
              <>
                <a href="/">Vindat</a>
                <ChevronRight />
                {this.lbl('vehicle.overview.title')}
                <ChevronRight />
                {this.vehicle?.brand_name}&nbsp;{this.vehicle?.model_name}&nbsp;{this.vehicle?.type}
              </>
            }
          />
          <LoadingDetailsPage version="versionVehicle" />
        </>
      );

    const back_url = this.props.history.location.pathname.slice(0, this.props.history.location.pathname.lastIndexOf('/'));

    return (
      <div className="container-fluid p-0">
        <PageHeader
          title={
            <div className="pointer" onClick={this.tofn(back_url)}>
              <Left />
              {this.lbl('vehicle.overview.transport')}
            </div>
          }
          breadCrumbs={
            <>
              <a href="/">Vindat</a>
              <ChevronRight />
              {this.lbl('vehicle.overview.transport')}
              <ChevronRight />
              {this.vehicle?.brand_name}&nbsp;{this.vehicle?.model_name}&nbsp;{this.vehicle?.type}
            </>
          }
        />

        <>
          <Switch>
            <TransportOrderDetailsColumns key={this.props.transportOrder.id} transportOrder={this.transportOrder} />
            <Route
              render={component => (
                <TransportOrderDetailsColumns key={this.props.transportOrder.id} transportOrder={this.transportOrder} />
              )}
            />
          </Switch>
        </>
      </div>
    );
  }
}

TransportOrderDetailsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    transportOrder: selectTransportOrder(ownProps.transportOrderId),
    work: selectWorks([REQUEST_TRANSPORT_ORDER]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchTransportOrder(ownProps.transportOrderId));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const TransportOrderDetails = compose(withConnect, withRouter)(TransportOrderDetailsComp);
